import AmexSecurityCenterProtectScams from './AmexSecurityCenterProtectScams';

export default AmexSecurityCenterProtectScams;
